export const ThreeDInterface = {
  methods: {
    insertLightingButton() {
      const toolbar = document.querySelector(
        '#CesiumContainer .cesium-viewer .cesium-viewer-toolbar'
      )
      const modeButton = document.querySelector(
        '#CesiumContainer .cesium-viewer .cesium-viewer-toolbar span.cesium-sceneModePicker-wrapper'
      )
      const lightingButton = document.getElementById('lighting-button')
      if (toolbar && modeButton && lightingButton) {
        toolbar.insertBefore(lightingButton, modeButton)
      }
    },

    toggleSecondViewer() {
      // gets line element in camera vg
      const line = document.querySelector('#video-off-line')
      const length = line.getTotalLength()
      if (this.secondViewer) {
        // clears and closes second viewer
        this.closeSecondViewer()
        // Clear any previous transition
        line.style.transition = line.style.WebkitTransition = 'none'
        // Set up the starting positions
        line.style.strokeDasharray = length + ' ' + length
        line.style.strokeDashoffset = 0
        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        line.getBoundingClientRect()
        // Define our transition
        line.style.transition = line.style.WebkitTransition =
          'stroke-dashoffset 0.5s ease-in-out'
        // Go!
        line.style.strokeDashoffset = length
      } else {
        this.initSecondViewer()
        // sets a timeout otherwise the animation plays before the end of the initialization
        window.setTimeout(() => {
          line.style.transition = line.style.WebkitTransition = 'none'
          line.style.strokeDasharray = length + ' ' + length
          line.style.strokeDashoffset = length
          line.getBoundingClientRect()
          line.style.transition = line.style.WebkitTransition =
            'stroke-dashoffset 0.5s ease-in-out'
          line.style.strokeDashoffset = '0'
        }, 500)
      }
    },

    updateElementsStyle(viewerId) {
      const animRing = document.querySelector(
        viewerId + ' .cesium-viewer-animationContainer'
      )
      const FirstViewer = document.querySelector(viewerId)
      const verticalIndicators = document.querySelectorAll(
        '.vertical-progress-indicator'
      )

      const currentTimeIndicator = document.querySelector(
        '#current-time-indicator'
      )
      const toggleTimelineButton = document.querySelector(
        '#toggle-timeline-button'
      )

      if (currentTimeIndicator && toggleTimelineButton) {
        currentTimeIndicator.style.left = `${
          Math.round(toggleTimelineButton.getBoundingClientRect().left) + 15
        }px`
      }

      const SCPanel = document.querySelector('#SCPanel-wrapper')
      if (animRing && FirstViewer && SCPanel && verticalIndicators) {
        const height = FirstViewer.offsetHeight - animRing.offsetHeight
        SCPanel.style.height = `${height}px`
        verticalIndicators.forEach((verticalIndicator, index) => {
          // everything is rotated by 270° so here width corresponds to apparent height
          verticalIndicator.style.width = `${0.9 * height - 20}px`
          verticalIndicator.style.transform = `rotate(270deg) translate(${
            (-0.9 * height) / 2
          }px, ${(-0.9 * height) / 2 + (index + 1) * 60}px`
          verticalIndicator.style.top = '20px'
        })
      }
    },

    toggleEventsTimeline() {
      this.displayTimeline ? this.hideTimeline() : this.showTimeline()
    },

    hideTimeline() {
      const timeline = document.querySelector('#scrollable-timeline')
      const toggleButton = document.querySelector('#toggle-timeline-button')
      const currTimeIndicator = document.querySelector(
        '#current-time-indicator'
      )

      timeline.style.marginTop = `${
        toggleButton.offsetHeight - timeline.offsetHeight
      }px`
      timeline.classList.replace('timeline-visible', 'timeline-hidden')
      toggleButton.firstChild.style.transform = 'rotateX(360deg)'
      timeline.style.backgroundColor = 'rgba(30, 30, 32, 0)'
      currTimeIndicator.style.height = '0px'
      currTimeIndicator.style.opacity = 0

      this.displayTimeline = false
    },

    showTimeline() {
      const timeline = document.querySelector('#scrollable-timeline')
      const toggleButton = document.querySelector('#toggle-timeline-button')
      const currTimeIndicator = document.querySelector(
        '#current-time-indicator'
      )

      timeline.style.marginTop = 0
      timeline.classList.replace('timeline-hidden', 'timeline-visible')
      toggleButton.firstChild.style.transform = 'rotateX(180deg)'
      timeline.style.backgroundColor = 'rgba(30, 30, 32, 0.3)'
      currTimeIndicator.style.opacity = 1
      currTimeIndicator.style.height = `${
        timeline.offsetHeight - toggleButton.offsetHeight
      }px`

      this.displayTimeline = true
    },

    toggleSCPanel() {
      this.displaySCPanel ? this.hideSCPanel() : this.showSCPanel()
    },

    hideSCPanel() {
      const SCPanel = document.querySelector('#SCPanel-wrapper')
      const toggleButton = document.querySelector('#toggle-SCPanel-button')

      SCPanel.style.left = `calc(${toggleButton.offsetHeight}px - 15%)`
      // SCPanel.style.width = `${toggleButton.offsetHeight}px`
      toggleButton.firstChild.style.transform = 'rotateX(360deg)'
      SCPanel.style.backgroundColor = 'rgba(30, 30, 32, 0)'
      SCPanel.classList.replace('panel-visible', 'panel-hidden')
      this.displaySCPanel = false
    },

    showSCPanel() {
      const SCPanel = document.querySelector('#SCPanel-wrapper')
      const toggleButton = document.querySelector('#toggle-SCPanel-button')

      SCPanel.style.left = 0
      toggleButton.firstChild.style.transform = 'rotateX(180deg)'
      SCPanel.style.backgroundColor = 'rgba(30, 30, 32, 0.3)'
      SCPanel.classList.replace('panel-hidden', 'panel-visible')
      this.displaySCPanel = true
    }
  }
}
